import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import { BllKasalar } from './../../providers/bll/bll-kasalar';
import { StokResimEkleGuncellePage } from './../StokIslemleri/stok-resim-ekle-guncelle/stok-resim-ekle-guncelle';
import { StokeklePage } from './../StokIslemleri/stokekle/stokekle';
import { HomePage } from './../home/home';
import { BllSiparisDetay } from './../../providers/bll/bll-siparis-detay';
import { ParaUstuModalPage } from './../PerakendeIslemleri/para-ustu-modal/para-ustu-modal';
import { CarisecPage } from './../faturaislemleri/carisec/carisec';
import { BLLViewCariler } from './../../providers/bll/bll-viewCariler';
import { HizliFiyatDegistirPage } from './../PerakendeIslemleri/hizli-fiyat-degistir/hizli-fiyat-degistir';
import { BllKategoriler } from './../../providers/bll/bll-kategoriler';
import { BllViewStoklar } from './../../providers/bll/bll-ViewStoklar';
import { ParametreAyarlariPage } from './../Yonetim/parametre-ayarlari/parametre-ayarlari';
import { Vw_Stoklar } from './../../models/Vw_Stoklar';
import { Vw_Cariler } from './../../models/Vw_Cariler';
import { NL_Kasa } from './../../models/NL_Kasa';
import { DalProvider } from './../../providers/dal/dal';
import { SyncProvider } from './../../providers/syncProvider';
import { ToastController } from 'ionic-angular/components/toast/toast-controller';
import { Ortak } from './../../providers/ortak';
import { BllOrtak } from './../../providers/bll/bll-ortak';
import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, LoadingController, ActionSheetController, Searchbar } from 'ionic-angular';

 
 
@Component({
  selector: 'page-perakende-satis-mobil',
  templateUrl: 'perakende-satis-mobil.html',
})
export class PerakendeSatisMobilPage {
  @ViewChild('sideNavUrunAra') sideNav;
  buttonColor:string='#000';
  indirimliGenelToplam: number = 0;
  onaylanmamisindirimliGenelToplam: number = 0;
  toplam: number = 0;
  toplamaratutar: number = 0;
  toplamIskonto: number = 0;
  siparisBaslikDurumID = 1;
  genelToplam: number = 0;
  editmode: number = 0;
  odenenToplam: number = 0;
  tempToplam: number = 0;
  aktifsatisekrani:number=-990;
  arananstokadi = "";
  aranan = "";
  AraSatisList=[];
  CalismaSekli: number = 3; //1 ise online 0 ise offline
  kategoriid: number = 0;
  KategoriListesi = [];
  StokListesi: Vw_Stoklar[] = [];
  StokCtrl = [];
  sideStokListesi = [];
  tempyazdirma: any = { ID: "", StokAdi: "", StokKartID: "", Miktar: "", BirimFiyat: "", Tutar: "" };
  sunucuadresi: any;
  base64Image: string;
  iadealimi: number = 0;
  kasiyeradi: any;
  sonsatistutari:number=0;
  kampanya: number = 0;
  KasaListesi: NL_Kasa[] = [];
  CariListesi: Vw_Cariler[] = [];
  pluList = [];
  ServerParamet: any = {
    ID: "", PesinSatisHesabi: "", OnTanimKasa: "", SatisSonrasiCariEkleme: "", SatisSirasindaStokMiktari: "", PLUFiyatGoster: "",
    KasiyerFiyatDegistirsinMi: "", KasiyerVeresiyeSatsinMi: "", KasiyerStokGirsinMi: "",SatisSirasindaCariEkleme: ""
  };
  filterCariList: any = { ID: "", Definition_: "" };
  miktar: number = 1;
  
  skip: number = 0;
  aranancari = "";
  aktifkullaniciyetkisi:"";
  islemyapan = this.ortak.aktifKullaniciAdi;
  ontanimlicariadi = "";
  fisyazicioto: number = 0;
  yaziciadi: any;
  onaylaPasif: boolean = false;
  islemdevamediyor: boolean = false;
  aktarilacakCariKart: any = { ID: "", Definition_: "" };
  aktifSiparisVeDetaylari: any = { SIPARIS_DETAYLARI: [] };
  @ViewChild('searchbar') searchbar: Searchbar;
  constructor(public navCtrl: NavController, 
    private barcodeScanner: BarcodeScanner,
    public bllOrtak: BllOrtak,
    public ortak: Ortak,
    public modalCtrl: ModalController,
    public toast: ToastController,
    public loadingCtrl: LoadingController,
    public syncProvider: SyncProvider,
    // public audio: NativeAudio,
    public actionSheetCtrl: ActionSheetController,
    public dalProvider: DalProvider,
    public navParams: NavParams) {
    this.aktifkullaniciyetkisi = this.ortak.kullaniciType;
    this.fisyazicioto = this.ortak.otoFisYazici;
    this.yaziciadi = this.ortak.aktifYazici;
    this.bllOrtak.islemWithoutPost("ParametreleriVer", "", false).then(a => {
      var sonuc = <any>a;
      this.ServerParamet = sonuc.SonucObject;
      this.aktarilacakCariKart.ID = this.ServerParamet.PesinSatisHesabi;
      this.sunucuadresi = this.ortak.storageSunucuAdresiGetir;
      if (this.ServerParamet.PesinSatisHesabi == null || this.ServerParamet.PesinSatisHesabi == "") {
        this.ortak.showBasicAlert("Hata", "Lütfen Ön Tanımlı Satış Hesabını Seçiniiz");
        let modal = this.modalCtrl.create(ParametreAyarlariPage);
        modal.onDidDismiss(data => {
          this.ionViewDidLoad();
        })
        modal.present();
      }
    })
    this.OfflineStokKontrol();
   // this.audio.preloadSimple("error", 'assets/sound/beep.wav');
    this.kasiyeradi = this.ortak.aktifKullaniciAdi;
    this.AraSatisList = [{
      "ID": "-990",
      "Adi": "Satış 1"
    },
    {
      "ID": "-991",
      "Adi": "Satış 2"
    },
    {
      "ID": "-992",
      "Adi": "Satış 3"
    },
    {
      "ID": "-993",
      "Adi": "Satış 4"
    }
    ];
  }
  ionViewDidLoad() {
    this.OfflineKategoriListesiGetir();
    this.KasalariGetir();
    this.OfflineCariGetir();
    this.siparisDetayListesi_Temp();
    this.PlueGetir();
  }
  ionViewDidEnter() {
    setTimeout(() => {
      this.searchbar.setFocus();
    });
  }

  OfflineStokKontrol() {
    var stoklar = new BllViewStoklar();
    stoklar.getAll().then(a => {
      var sonuc = <any>a;
      this.StokCtrl = sonuc;
      if (this.StokCtrl.length > 0) {
        this.CalismaSekli = 0;
      }
      else {
        this.veribossa();
      }

    });
  }
  OfflineKategoriListesiGetir() {
    var kategoriler = new BllKategoriler();
    kategoriler.getAllWithSpecificQuery("(replace(replace(replace(replace(replace(replace(replace(KategoriAdi,'İ','i'),'Ö','ö'),'Ç','ç'),'I','ı'),'Ğ','ğ'),'Ü','ü'),'Ş','ş') like '%" + this.aranan + "%' or KategoriAdi='" + this.aranan + "')" + " order by Sort").then(a => {
      var sonuc = <any>a;
      this.KategoriListesi = sonuc;
    });

  }
  OnlineKategoriGetir() {
    this.bllOrtak.islemWithoutPost("PerakendeKategoriList", "", false).then(a => {
      var sonuc = <any>a;
      this.KategoriListesi = sonuc.SonucObject;

    })
  }
  FiyatDegistir() {
    let modal = this.modalCtrl.create(HizliFiyatDegistirPage);
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    })
    modal.present();
  }
  OnlineCarileriGetir() {
    var formData = new FormData();
    formData.append("aranan", this.aranancari);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.ortak.StAyarGetir.CariListeSayisi.toString());
    this.bllOrtak.islem(formData, "CariListesi", "Yükleniyor", false).then(a => {
      var sonuc = <any>a;
      this.CariListesi = sonuc.SonucObject;
      this.filterCariList = this.CariListesi.filter(a => a.ID == this.aktarilacakCariKart.ID);
      this.filterCariList.forEach(element => {
        this.aktarilacakCariKart.Definition_ = element.Definition_;
        this.ontanimlicariadi = element.Definition_;
      });
    })
  }
  OfflineCariGetir() {
    var bllViewCariler = new BLLViewCariler();
    bllViewCariler.getAllWithSpecificQuery("(replace(replace(replace(replace(replace(replace(replace(Definition_,'İ','i'),'Ö','ö'),'Ç','ç'),'I','ı'),'Ğ','ğ'),'Ü','ü'),'Ş','ş') like '%" + this.aranan + "%' or Kodu='" + this.aranan + "')" + " order by ID").then(a => {
      var sonuc = <any>a;
      this.CariListesi = sonuc;
      if (this.CariListesi.length == 0) {
        this.OnlineCarileriGetir();
      }
      this.filterCariList = this.CariListesi.filter(a => a.ID == 1);
      this.filterCariList.forEach(element => {
        this.aktarilacakCariKart.Definition_ = element.Definition_;
        this.ontanimlicariadi = element.Definition_;
      });
    });

  }
  PlueGetir() {
    var bllViewStoklar = new BllViewStoklar();
    if (this.kategoriid == 0) {
      var asd: number = 1;
      bllViewStoklar.getAllWithSpecificQuery("(KategoriID='" + asd + "' and PLU='true')").then(a => {
        this.pluList = a;
        this.searchbar.setFocus();
      });
    }
    else {
      bllViewStoklar.getAllWithSpecificQuery("(KategoriID='" + this.kategoriid + "' and PLU='true')").then(a => {
        this.pluList = a;
        this.searchbar.setFocus();
      });
    }


  }

  OfflineUrunAra(e, otoEkle) {
    var miktar: number = 1;
    if (this.aranan.split("*").length > 1) {
      miktar = parseFloat(this.aranan.split("*")[0]);
      this.aranan = this.aranan.split("*")[1];
    }
    var barkod = this.aranan;
    var strmiktar = parseFloat(this.aranan.substring(7, 12));
    if (this.aranan.length == 13 && (this.aranan.substring(0, 2) == "27" || this.aranan.substring(0, 2) == "28")) {
      barkod = this.aranan.substring(0, 7);
      if (strmiktar != 0) {
        miktar = strmiktar / 1000;
      }
      else {
        alert("Hatalı Barkod");
      }
    }
    else if (this.aranan.length == 13 && (this.aranan.substring(0, 2) == "29")) {
      barkod = barkod.substring(0, 7);
      if (strmiktar != 0) {
        miktar = strmiktar;
      }
      else {
        alert("Hatalı Barkod");
      }
    }
    this.aranan = barkod;

    var bllViewStoklar = new BllViewStoklar();
    bllViewStoklar.getAllWithSpecificQuery("(Barcode1='" + this.aranan + "'or Barcode2='" + this.aranan + "')").then(a => {
      this.StokListesi = a;
      if (this.StokListesi.length == 1) {
        if (otoEkle == true) {
          this.urunItemClick(this.StokListesi[0], miktar);
          this.aranan = "";
          this.searchbar.setFocus();
        }
      }

      else if (this.StokListesi.length == 0) {

        this.ortak.showConfirmAlert2("Uyarı", "Ürün Bulunamadı Eklemek İstermisiniz?..").then(a => {
          var modal = this.modalCtrl.create(StokeklePage, { vwPStokEkle: this.aranan });
          modal.onDidDismiss(a => {
            this.aranan = a;
            this.eklemesonrasiekle();
          });
          modal.present();
        }).catch(x => {
          this.focusla();
        });
      }
    });

  }
  focusla() {
    this.aranan = "";
    this.searchbar.setFocus();
  }
  eklemesonrasiekle() {
    var bllViewStoklar = new BllViewStoklar();
    bllViewStoklar.getAllWithSpecificQuery("(Barcode1='" + this.aranan + "'or Barcode2='" + this.aranan + "')").then(a => {
      this.StokListesi = a;
      if (this.StokListesi.length == 1) {
        this.urunItemClick(this.StokListesi[0], 1);
        this.aranan = "";
        this.PlueGetir();
        this.searchbar.setFocus();
      }
    });
  }
  StokAdiileAra(e) {
    if (e.keyCode == 13) {
      var bllViewStoklar = new BllViewStoklar();
      bllViewStoklar.getAllWithSpecificQuery("(replace(replace(replace(replace(replace(replace(replace(StokAdi,'İ','i'),'Ö','ö'),'Ç','ç'),'I','ı'),'Ğ','ğ'),'Ü','ü'),'Ş','ş') like '%" + this.arananstokadi + "%' or Kodu='" + this.arananstokadi + "')").then(a => {
        this.sideStokListesi = a;
      });
    }
  }
  IadeAl() {
    if (this.iadealimi == 0) {
      this.iadealimi = 1;
      this.cacheTemizle();
    }
    else if (this.iadealimi == 1) {
      this.iadealimi = 0;
      this.aktarilacakCariKart.ID = this.ServerParamet.PesinSatisHesabi;
      this.cacheTemizle();
    }

  }
  KampanyaModu() {
    if (this.kampanya == 0) {
      this.kampanya = 1;
     // this.cacheTemizle();
    }
    else if (this.kampanya == 1) {
      this.kampanya = 0;
      this.aktarilacakCariKart.ID = this.ServerParamet.PesinSatisHesabi;
    //  this.cacheTemizle();
    }
  }
  CariDegistir() {
    if (this.ServerParamet.KasiyerVeresiyeSatsinMi == true) {
      var modal = this.modalCtrl.create(CarisecPage);
      modal.onDidDismiss(a => {
        if (a != null) {
          this.aktarilacakCariKart = a;
          if (this.aktarilacakCariKart.ID > 1) {
            this.ionViewDidEnter();
          }
          else {this.ionViewDidEnter();
          }
        }
      });
      modal.present();
    }
    else {
      this.ortak.showBasicAlert("Uyarı", "Bu işlemi yapmaya yetkiniz yok");
    }
  }
  KasalariGetir() {
    var bllkasalar = new BllKasalar();
    bllkasalar.getAll({ OdemeTipi: true }).then(a => {
      var sonuc = <any>a;
      this.KasaListesi = sonuc;
    });
  }
  ParametreleriAl() {
    this.bllOrtak.islemWithoutPost("ParametreleriVer", "", false).then(a => {
      var sonuc = <any>a;
      this.ServerParamet = sonuc.SonucObject;
      this.aktarilacakCariKart.ID = this.ServerParamet.PesinSatisHesabi;
    })
  }
  kategorisec(kategori) {
    this.kategoriid = kategori.ID;
    this.PlueGetir();
  }
  ParaUstu() {
    let modal = this.modalCtrl.create(ParaUstuModalPage, { toplam: this.toplam },{cssClass:"genisekran"});
    modal.onDidDismiss(data => {
      this.aranan="";
      this.searchbar.setFocus();
      this.ionViewDidEnter();
    })
    modal.present();
    this.searchbar.setFocus();
  }

  urunler(e) {
    if (e.keyCode == 13) {
      this.OfflineUrunAra(-1, true);
    }
    if (e.keyCode == 61) {
      this.f1Kaydet();
    }
    if (e.keyCode == 45) {
      this.cacheTemizle();
    }
  }


  presentToast(mesaj) {
    let toast = this.toast.create({
      message: mesaj,
      duration: 1000,
      showCloseButton: true,
      position: 'top'
    });
    toast.present();

  }
  urunItemClick(stok, miktar) {

    if (this.editmode == 1) {
      this.EditingIslemler(stok);
    }
    else {
      if (miktar == "") {
        miktar = 1;
      }
      else {
        this.miktar = miktar;
      }

      var bllSiparisDetay = new BllSiparisDetay();
      if (this.kampanya == 1) {
        
        bllSiparisDetay.satinAlmaDetayEkle_Temp(this.aktarilacakCariKart.ID, stok.ID, this.miktar, stok.StokAdi, 8, this.aktifsatisekrani, 0, stok.Price1, 255, this.islemyapan,stok.Kalan).then(a => {
          this.siparisDetayListesi_Temp();
          this.searchbar.setFocus();
        });
      }
      else {
        bllSiparisDetay.satinAlmaDetayEkle_Temp(this.aktarilacakCariKart.ID, stok.ID, this.miktar, stok.StokAdi, 8, this.aktifsatisekrani, stok.Price2, stok.Price1, 255, this.islemyapan,stok.Kalan).then(a => {
          this.siparisDetayListesi_Temp();
          this.searchbar.setFocus();
        });
      }
      this.closeNav();
      this.onaylaPasif = false;
      this.searchbar.setFocus();
    }


  }
  barkodOkut() {
    this.barcodeScanner.scan().then(a => {
      var sonuc = <any>a;
      this.aranan = sonuc.text;
      this.OfflineUrunAra(-1, true);
    })
  }
  satisekranchange(ekran)
  {
    this.buttonColor = '#345465';
    this.aktifsatisekrani=ekran.ID;
    this.siparisDetayListesi_Temp();
    this.ionViewDidEnter();
  }
  siparisDetayListesi_Temp() {
    var bllSiparisDetay = new BllSiparisDetay();
    bllSiparisDetay.getAll({ siparisID: this.aktifsatisekrani }).then(a => {
      this.aktifSiparisVeDetaylari.SIPARIS_DETAYLARI = this.aktifSiparisVeDetaylari.SIPARIS_DETAYLARI.filter(a => a.SIPARIS_DURUM_ID != 255);
      this.aktifSiparisVeDetaylari.SIPARIS_DETAYLARI = this.aktifSiparisVeDetaylari.SIPARIS_DETAYLARI.concat(a);
      this.aktifSiparisVeDetaylari.SIPARIS_DETAYLARI = this.aktifSiparisVeDetaylari.SIPARIS_DETAYLARI.sort((c1, c2) => c1.SIPARIS_DURUM_ID < c2.SIPARIS_DURUM_ID);
      this.fiyatHesapla(this.aktifSiparisVeDetaylari.SIPARIS_DETAYLARI.filter(a => a.SIPARIS_DURUM_ID != 255), a);

    });
 //   console.log("sipDate",this.aktifSiparisVeDetaylari.SIPARIS_DETAYLARI);
 
  }
  fiyatHesapla(onaylanmisSiparisDetaylari, onaylanmamisSiparisDetaylari) {
    this.genelToplam = 0;
    this.toplam = 0;
    this.odenenToplam = 0;
    this.toplamaratutar = 0;
    this.onaylanmamisindirimliGenelToplam = 0;
    onaylanmamisSiparisDetaylari.forEach(item => {
      var satirToplamTutar = item.BirimFiyat * item.Miktar;
      this.toplam = this.toplam + satirToplamTutar;
      this.toplamaratutar += item.AraTutar;
    });
  }
  cacheTemizle() {
    var siparisID = this.aktifsatisekrani;
    this.onaylaPasif = true;
    var bllSiparisDetay = new BllSiparisDetay();
    bllSiparisDetay.execRawQuery("DELETE FROM NL_Siparis WHERE siparisID = " + siparisID).then(b => {
      this.siparisDetayListesi_Temp();
      this.onaylaPasif = true;
      this.aranan = "";
      this.searchbar.setFocus();
      this.islemdevamediyor=false;

    }).catch(x => {
    })
    this.aranan = "";
    this.ionViewDidLoad();
  }

  miktarAzalt(detay) {
    if (detay.SIPARIS_DURUM_ID == 255) {
      if (detay.Miktar == 1) {
        this.siparisSil(detay);
        this.searchbar.setFocus();
      }
      else if (detay.Miktar >= 2) {
        detay.Miktar = detay.Miktar - 1;
        this.miktarChange(detay);
        this.searchbar.setFocus();
      }
      else if (detay.Miktar < 2 && detay.Miktar > 0) {
        detay.Miktar = detay.Miktar - 1;
        this.miktarChange(detay);
        this.searchbar.setFocus();
      }
    }
  }
  miktarArttir(detay) {
    if (detay.SIPARIS_DURUM_ID == 255)
      detay.Miktar = detay.Miktar + 1; this.miktarChange(detay)
  }
  miktarDegistir(e, detay) {
    this.miktarChange(detay);
  }

  miktarChange(detay) {
    if (detay.SIPARIS_DURUM_ID == 255) {
      if (detay.Miktar != "") {
        if (detay.Miktar >= 1) {
          var bllSiparisDetay = new BllSiparisDetay();
          bllSiparisDetay.miktarGuncelle(detay).then(a => {
            this.siparisDetayListesi_Temp();
            this.searchbar.setFocus();
          }).catch(x => {
          })
        }
        else
          detay.Miktar = 1;
        this.searchbar.setFocus();
      }
    }
  }

  birimFiyatChange(e, detay) {
    
      if (e.keyCode == 13) {
        if (detay.BirimFiyat != "" && detay.BirimFiyat >= 0) {
          var bllSiparisDetay = new BllSiparisDetay();
          bllSiparisDetay.birimFiyatGuncelle(detay).then(a => {
            this.siparisDetayListesi_Temp();
            this.searchbar.setFocus();
          })
        }
      }
    
  }
  siparisSil(detay) {
    if (detay.SIPARIS_DURUM_ID == 255) {
      var bllSiparisDetay = new BllSiparisDetay();
      bllSiparisDetay.delete({ ID: detay.ID }).then(a => {
        this.siparisDetayListesi_Temp();
        this.searchbar.setFocus();
      }).catch(x => {
      })
    }
  }
  tempyazdir() {
    var bllSiparisDetay = new BllSiparisDetay();
    bllSiparisDetay.getAll({siparisID:this.aktifsatisekrani}).then(a => {
      var formData = new FormData();
      formData.append("siparis_detaylari_json", JSON.stringify(a));
      formData.append("cariid", this.aktarilacakCariKart.ID.toString());
      formData.append("toplam", this.toplam.toString());
      formData.append("yaziciadi", this.yaziciadi);
      this.bllOrtak.yazdir(formData, "PerakendeYazdir", "", false).then(a => {
      }).catch(x => {
        this.onaylaPasif = false;
        this.ionViewDidEnter();
      })
    });
  }
  SonFisYazdir()
  {
    var formData=new FormData();
    formData.append("yaziciadi",this.yaziciadi);
    this.bllOrtak.islem(formData,"SonFisYazdir","",false).then(a=>{
    this.ionViewDidEnter();
    });
  }
  onayla(kasa) {

    this.CariDegistir();
    this.sonsatistutari=this.toplam;
    this.onaylaPasif = true;
    var siparisID = -this.aktifsatisekrani;
    var bllSiparisDetay = new BllSiparisDetay();

if(this.islemdevamediyor==false)
{

this.islemdevamediyor=true;
if(this.toplam>0)
 {
    bllSiparisDetay.getAll({ siparisID:this.aktifsatisekrani  }).then(a => {
      var formData = new FormData();
      formData.append("siparis_detaylari_json", JSON.stringify(a));
      formData.append("cariid", this.aktarilacakCariKart.ID.toString());
      formData.append("kasaid", kasa.ID.toString());
      formData.append("toplam", this.toplam.toString());
      formData.append("fisbasilacakmi", this.fisyazicioto.toString());
      formData.append("yaziciadi", this.yaziciadi);
      formData.append("slsman", this.kasiyeradi.toString());
      formData.append("aratutar", this.toplamaratutar.toString());
    
    
      this.bllOrtak.islem(formData, "PerakendeSatis", "", false).then(a => {
           var sonuc=<any>a;
          bllSiparisDetay.execRawQuery("DELETE FROM NL_Siparis WHERE siparisID = " + this.aktifsatisekrani).then(b => {
          this.siparisDetayListesi_Temp();
          this.aktarilacakCariKart.ID = this.ServerParamet.PesinSatisHesabi;
          this.aktarilacakCariKart.Definition_ = this.ontanimlicariadi;
          
          this.islemdevamediyor=false;
        });
      
        if(sonuc.Sonuc==99)
        {
          this.ortak.showBasicAlert("Hata","Beklenmedik bir hata oluştu");
          this.islemdevamediyor=false;
        }   
 
      }).catch(x => {
        this.onaylaPasif = false;
        console.log(x);
        this.islemdevamediyor=false;
    
      })
    }).catch(x => {
      this.onaylaPasif = false;
      this.ortak.showErrorAlert();
      this.islemdevamediyor=false;

    });
  }
  else
  this.islemdevamediyor=false
}
    this.searchbar.setFocus();
 
  }
  SatisIade() {
    this.onaylaPasif = true;
    var kasaid: number = 1;
    var bllSiparisDetay = new BllSiparisDetay();
    bllSiparisDetay.getAll({siparisID:this.aktifsatisekrani}).then(a => {
      var formData = new FormData();
      formData.append("siparis_detaylari_json", JSON.stringify(a));
      formData.append("cariid", this.aktarilacakCariKart.ID.toString());
      formData.append("kasaid", kasaid.toString());
      formData.append("toplam", this.toplam.toString());
      this.bllOrtak.islem(formData, "PerakendeSatisIade", "", false).then(a => {
        bllSiparisDetay.execRawQuery("DELETE FROM NL_Siparis WHERE siparisID = " + this.aktifsatisekrani).then(b => {
          this.siparisDetayListesi_Temp();
          this.aktarilacakCariKart.ID = this.ServerParamet.PesinSatisHesabi;
          this.aktarilacakCariKart.Definition_ = this.ontanimlicariadi;
          this.iadealimi = 0;
        })
      }).catch(x => {
        this.onaylaPasif = false;
        console.log(x);
        this.iadealimi = 0;
      })
    }).catch(x => {
      this.onaylaPasif = false;
      this.ortak.showErrorAlert();
      this.iadealimi = 0;
    })
    this.iadealimi = 0;
    this.searchbar.setFocus();
    this.ionViewDidEnter();
  }

  veresiyeOnayla() {
    this.onaylaPasif = true;
    var bllSiparisDetay = new BllSiparisDetay();
    bllSiparisDetay.getAll({siparisID:this.aktifsatisekrani}).then(a => {
      var formData = new FormData();
      formData.append("siparis_detaylari_json", JSON.stringify(a));
      formData.append("cariid", this.aktarilacakCariKart.ID.toString());
      formData.append("kasaid", this.ServerParamet.OnTanimKasa.toString());
      formData.append("fisbasilacakmi", this.fisyazicioto.toString());
      formData.append("toplam", this.toplam.toString());
      formData.append("slsman", this.kasiyeradi.toString());
      formData.append("aratutar", this.toplamaratutar.toString());
      formData.append("yaziciadi", this.yaziciadi);
      this.bllOrtak.islem(formData, "PerakendeSatis", "", false).then(a => {
        bllSiparisDetay.execRawQuery("DELETE FROM NL_Siparis WHERE siparisID = " + this.aktifsatisekrani).then(b => {
          this.siparisDetayListesi_Temp();
          this.aktarilacakCariKart.ID = this.ServerParamet.PesinSatisHesabi;
          this.aktarilacakCariKart.Definition_ = this.ontanimlicariadi;
          this.ionViewDidLoad();

        }).catch(x => {
          console.log(x);
        })
      }).catch(x => {
        this.onaylaPasif = false;
        console.log(x);
      })
    }).catch(x => {
      this.onaylaPasif = false;
      this.ortak.showErrorAlert();
    })
  }
  f1Kaydet() {
    this.onaylaPasif = true;
    var siparisID = this.aktifsatisekrani;
    var bllSiparisDetay = new BllSiparisDetay();
    bllSiparisDetay.getAll().then(a => {
      if (a != null) {
        var formData = new FormData();
        formData.append("siparis_detaylari_json", JSON.stringify(a));
        formData.append("cariid", this.aktarilacakCariKart.ID.toString());
        formData.append("kasaid", this.ServerParamet.OnTanimKasa.toString());
        formData.append("toplam", this.toplam.toString());
        formData.append("fisbasilacakmi", this.fisyazicioto.toString());
        this.bllOrtak.islem(formData, "PerakendeSatis", "", false).then(a => {
          bllSiparisDetay.execRawQuery("DELETE FROM M_SIPARIS_DETAY WHERE siparisID = " + siparisID).then(b => {
            this.siparisDetayListesi_Temp();
          }).catch(x => {
            console.log(x);
          })
        }).catch(x => {
          this.onaylaPasif = false;
          console.log(x);
        })
      }
    }).catch(x => {
      this.onaylaPasif = false;
      this.ortak.showErrorAlert();
    })
  }
  cikis() {
    this.navCtrl.setRoot(HomePage);
  }
  VerileriYenile() {
     let loading = this.loadingCtrl.create({
       content: "Stoklar Getiriliyor"
     });
    loading.present();
    this.syncProvider.stokBilgisiSunucudanGetir().then(a => {
      loading.dismiss();
    }).catch(x => {
     loading.dismiss();
      this.cariKartlariGetir();
    });
  }

  cariKartlariGetir() {
    //  let loading = this.loadingCtrl.create({
    //   content: "Cari Kartlar Getiriliyor"
    //  });
    //  loading.present();
    this.syncProvider.cariKartiSunucudanGetir().then(a => {
  //   loading.dismiss();
    }).catch(x => {
  //   loading.dismiss();
      this.cariKartBilgileriniGetir();
    });
  }
  cariKartBilgileriniGetir() {
    // let loading = this.loadingCtrl.create({
    //   content: "Cari Kart Bilgileri Getiriliyor"
    // });
    // loading.present();
    this.syncProvider.cariKartViewSunucudanGetir().then(a => {
      //loading.dismiss();
    }).catch(x => {
     // loading.dismiss();
      this.kategoriler();
    });
  }
  kategoriler() {
    // let loading = this.loadingCtrl.create({
    //   content: "Kategoriler Getiriliyor"
    // });
    // loading.present();
    this.syncProvider.KategorileriSunucudanGetir().then(a => {
     //loading.dismiss();
    }).catch(x => {
    //   loading.dismiss();
      this.kasalar();
    });
  }
  kasalar() {
    // let loading = this.loadingCtrl.create({
    //   content: "Kasalar Getiriliyor"
    // });
    // loading.present();
    this.syncProvider.KasalariSunucudanGetir().then(a => {
  //   loading.dismiss();
     this.ionViewDidEnter();
   this.ionViewDidLoad();
 
    }).catch(x => {
    //   loading.dismiss();
      this.ionViewDidLoad();
      this.ionViewDidEnter();
    });
  }
  veribossa() {
    Ortak.sqlType = "web";
    var sqlDriver;
    if (Ortak.sqlType == "web") {
      sqlDriver = {
        database: "VT.db",
        type: "websql",
        storage: "sqlite",
      };
    }
    else {
      sqlDriver = {
        database: "VT.db",
        type: "websql",
        storage: "sqlite",
      };
    }
    return new Promise((res, err) => {
      this.dalProvider.PerakendeSatisSifirlama().then(a => {
        this.dalProvider.createAndGetConnection(sqlDriver).then(k => {
          res();

          this.VerileriYenile();
        });
      }).catch(z => {
        err();
        console.log(z);
      })
    })
  }
  sifirla() {
    this.ortak.showConfirmAlert("Uyarı", "Tüm veriler yenilecenek").then(a => {
      Ortak.sqlType = "web";
      var sqlDriver;
      if (Ortak.sqlType == "web") {
        sqlDriver = {
          database: "VT.db",
          type: "websql",
          storage: "sqlite",
        };
      }
      else {
        sqlDriver = {
          database: "VT.db",
          type: "websql",
          storage: "sqlite",
        };
      }
      return new Promise((res, err) => {
        this.dalProvider.PerakendeSatisSifirlama().then(a => {
          this.dalProvider.createAndGetConnection(sqlDriver).then(k => {
            res();

            this.VerileriYenile();
          });
        }).catch(z => {
          err();
          console.log(z);
        })
      })
    });
  }
  openNav() {
    let sideElement = this.sideNav.nativeElement
    sideElement.style.display = "block";
  }
  closeNav() {
    this.arananstokadi = "";
    let sideElement = this.sideNav.nativeElement;
    sideElement.style.display = "none";
    this.searchbar.setFocus();
  }
  editmodonoff() {
    if (this.editmode == 0) {
      this.editmode = 1;
    }
    else if (this.editmode == 1) {
      this.editmode = 0;
      this.searchbar.setFocus();
    }
  }
  EditStokKarti(Stok) {
 
      let modal = this.modalCtrl.create(StokeklePage, { vwUrun: Stok }, { cssClass: "genisekran" });
      modal.onDidDismiss(data => {
        this.PlueGetir();
      });
      modal.present();
  

  
  }
  resimEkleGuncelle(Stok) {
    let modal = this.modalCtrl.create(StokResimEkleGuncellePage, { stok: Stok });
    modal.onDidDismiss(data => {
      this.PlueGetir();
    })
    modal.present();
  }
  EditingIslemler(Stok) {
    const actionSheet = this.actionSheetCtrl.create({
      title: Stok.StokAdi,
      buttons: [
        {
          text: 'Resim Ekle ',

          handler: () => {
            this.resimEkleGuncelle(Stok);
          }
        },
        {
          text: 'Stok Kartını Düzenle',

          handler: () => {
            this.EditStokKarti(Stok);
          }

        },
        {
          text: 'İptal ',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    actionSheet.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/perakende-satis-mobil/perakende-satis-mobil.ts